module.exports = __webpack_public_path__ + "img/track-arrow.038ea343.svg";